<div class="banner">
  <h1>{{ 'contacts.page.title' | translate }}</h1>
</div>
<div class="container mt-4">
  <h3>{{ 'contacts.page.title' | translate }}</h3>
  <fgb-contacts-management></fgb-contacts-management>
</div>
